// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"472609a4","135":"76918568","144":"6ac6237b","150":"821d0d45","234":"0936a813","236":"3357e3af","414":"1e16fb80","452":"e58e0e92","453":"6d6381f5","480":"593c4bd4","537":"97b1c3ed","617":"84f05a42","843":"04636a6a","858":"b0b41051","885":"963707fd","928":"1925b52f"}[chunkId] + ".chunk.js";
};